export default [
    {
        path: '/products',
        name: 'products-index',
        meta: { title: 'Produits' },
        component: () => import('@/views/products/Index.vue'),
        redirect: { name: 'products-form', params: { id: 'list' } },
        children: [
            {
                path: 'p/:id',
                name: 'products-form',
                meta: { title: 'Liste des produits' },
                component: () => import('@/views/products/ProductsManager.vue')
            },
            {
                path: 'prices-families',
                name: 'prices-families',
                meta: { title: 'Tarifs et familles' },
                component: () => import('@/views/products/PriceFamilyManager.vue')
            },
            {
                path: 'suppliers',
                name: 'suppliers',
                meta: { title: 'Fournisseurs' },
                component: () => import('@/views/products/supplier/SupplierList.vue')
            },
            {
                path: 'suppliers/:id',
                name: 'supplierDetails',
                meta: { title: 'Détails du Fournisseur' },
                component: () => import('@/views/products/supplier/SupplierEdit.vue')
            },
            {
                path: 'stocks',
                name: 'stocks',
                meta: { title: 'Stock du produit' },
                component: () => import('@/views/products/StockManager.vue')
            },
            {
                path: 'stocks/:id',
                name: 'stocksDetails',
                meta: { title: 'Stock du produit' },
                component: () => import('@/views/products/StockManager.vue')
            },
            {
                path: 'periods',
                name: 'periods',
                meta: { title: 'Gestion des périodes' },
                component: () => import('@/views/products/PeriodManager.vue')
            },
            {
                path: 'collections',
                name: 'collections',
                meta: { title: 'Gestion des collections' },
                component: () => import('@/views/products/collection/CollectionList.vue')
            },
            {
                path: 'collections/:id',
                name: 'collections-edit',
                meta: { title: 'Edition d\'une collection' },
                component: () => import('@/views/products/collection/CollectionEdit.vue')
            }
        ]
    }
]
